module.exports = __webpack_public_path__ + "static/media/Drinks.03aa73b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Drinks.png
// module id = 131
// module chunks = 0